// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"37":"bb6440f7","114":"266e2dcc","286":"d84ba812","402":"c3fb6094","743":"ef4a4981","994":"278b2bb3"}[chunkId] + ".css";
};